import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import Education from './components/Education/Education';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import CVPage from './pages/CVPage/CVPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function MainPortfolio() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Education />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    // If user accesses /cv directly without hash (e.g. in dev server or direct URL), seamlessly redirect to #/cv
    if (window.location.pathname.endsWith('/cv')) {
      window.location.replace(`${window.location.origin}/#/cv`);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPortfolio />} />
          <Route path="/cv" element={<CVPage />} />
          <Route path="*" element={<MainPortfolio />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
